





























































































































































import _ from "lodash";
import { Component, Vue } from "vue-property-decorator";
import router from "@/router";
import rest from "@/rest";
// components
import SimpleMessageBox from "@/components/Shared/SimpleMessageBox.vue";
import TrainingEventCreateDialog from "@/components/Academy/TrainingEventCreateDialog.vue";
// interfaces
import { TrainingEventListItemVm } from "@/interfaces/TrainingEventListItemVm";
import { TrainingEventStatus } from "@/interfaces/TrainingEventStatus";
import { ParamDictionary } from "@/interfaces/ParamDictionary";
import { namespace } from "vuex-class";
import { OrganizationVm } from "@/interfaces/OrganizationVm";
import { vuex } from "@/store";
import { List } from "linq-collections";


const globals = namespace("globals");

@Component({
  components: {
    SimpleMessageBox,
    TrainingEventCreateDialog
  }
})
export default class TrainingEventsView extends Vue {
  readonly breadcrumbs = [
    { text: "Start", to: "/", exact: true },
    { text: "Veranstaltungen", disabled: true }
  ];

  readonly statusOptions: Array<{ label: string; value: TrainingEventStatus | null }> = [
    { label: "Alle", value: null },
    { label: "Entwurf", value: TrainingEventStatus.Draft },
    { label: "Veröffentlicht", value: TrainingEventStatus.Published },
    { label: "Abgesagt", value: TrainingEventStatus.Cancelled },
    { label: "Archiviert", value: TrainingEventStatus.Archived }
  ];

  @globals.Getter selectedOrg!: OrganizationVm;

  organizations: OrganizationVm[] = [];
  localSelectedOrg: OrganizationVm | null = null;
  // organizationId: number | null = null;
  loadingOrganizations = true;

  events: TrainingEventListItemVm[] = [];
  loading = false;

  search = "";
  statusFilter: TrainingEventStatus | null = null;

  showCreateDialog = false;
  highlightId: number | null = null;

  showErrorDialog = false;
  errorText = "";
  showSnackbar = false;
  snackbarText = "";

  async mounted(): Promise<void> {
    await this.loadOrganizations();
    await this.loadEvents();
  }

  get statusFilterLabel(): string {
    return this.statusOptions.find(o => o.value === this.statusFilter)?.label || "Alle";
  }

  // Events with upcoming appointments first (earliest first), events without appointments at the end
  get filteredEvents(): TrainingEventListItemVm[] {
    const term = (this.search || "").trim().toLowerCase();
    const filtered = this.events.filter(e => {
      if (this.statusFilter !== null && e.status !== this.statusFilter) return false;
      if (!term) return true;
      return (e.title || "").toLowerCase().includes(term) || (e.description || "").toLowerCase().includes(term);
    });
    return _.orderBy(filtered, [e => this.toTime(e.nextAppointmentStart), e => (e.title || "").toLowerCase()], ["asc", "asc"]);
  }

  async onOrgChanged() {
    vuex.globals.setOrg(this.localSelectedOrg);
    await this.loadEvents();
  }

  async loadOrganizations(): Promise<void> {
    try {
      this.loadingOrganizations = true;
        const selectedOrgId = this.selectedOrg?.id ?? 0
        // On errors the rest wrapper shows the message and returns undefined
        this.organizations = (await rest.url("trainingLead/getOrganizations").get()) ?? [];

        // If exist, select current org again
        if (this.organizations.length > 0) {
          if (selectedOrgId > 0) {
            let org = new List(this.organizations).singleOrDefault(s => s.id == selectedOrgId) ?? this.organizations[0];
            vuex.globals.setOrg(org);
          } else {
            vuex.globals.setOrg(this.organizations[0]);
          }
        } else {
          vuex.globals.setOrg(null);
        }
        this.localSelectedOrg = this.selectedOrg;
    } catch (error) {
      // this.showError("Die Organisationen konnten nicht geladen werden.");
    } finally {
      this.loadingOrganizations = false;
    }
  }

  async loadEvents(): Promise<void> {
    if (!this.selectedOrg?.id || this.selectedOrg.id == 0) return;

    this.loading = true;
    try {
      this.events = [];

      let params: ParamDictionary = { dictionary: {}};
      params.dictionary!["OrgId"] = this.selectedOrg.id.toString();
      this.events = (await rest.url("trainingLead/getEvents").post(params)) ?? [];

    } catch (error) {
      // this.showError("Die Veranstaltungen konnten nicht geladen werden.");
    } finally {
      this.loading = false;
    }
  }

  async onCreated(eventId: number): Promise<void> {
    await this.loadEvents();
    this.highlightId = eventId;
    window.setTimeout(() => (this.highlightId = null), 4000);
    this.snackbarText = "Veranstaltung angelegt (Entwurf). Als Nächstes können Termine hinzugefügt werden.";
    this.showSnackbar = true;
  }

  openEvent(item: TrainingEventListItemVm): void {
    // The editor reads the selected event from the ux store
    vuex.globals.setEvent(item);
    router.push({ name: "TrainingEventEditView", params: { id: String(item.id) } });
  }

  statusMeta(status: TrainingEventStatus): { text: string; color: string } {
    switch (status) {
      case TrainingEventStatus.Published:
        return { text: "Veröffentlicht", color: "success" };
      case TrainingEventStatus.Cancelled:
        return { text: "Abgesagt", color: "error" };
      case TrainingEventStatus.Archived:
        return { text: "Archiviert", color: "grey" };
      default:
        return { text: "Entwurf", color: "grey darken-1" };
    }
  }

  groupText(item: TrainingEventListItemVm): string {
    if (item.assignedGroupCount === 0) return "Keine Gruppe zugewiesen";
    return item.assignedGroupCount === 1 ? "1 Gruppe zugewiesen" : `${item.assignedGroupCount} Gruppen zugewiesen`;
  }

  scheduleText(item: TrainingEventListItemVm): string {
    if (item.appointmentCount === 0) return "Noch keine Termine";

    const count = item.appointmentCount === 1 ? "1 Termin" : `${item.appointmentCount} Termine`;
    if (!item.nextAppointmentStart) return `${count} · alle in der Vergangenheit`;
    return `${count} · nächster: ${this.$globalHelper.toLocalDateTimeWeekdayString(item.nextAppointmentStart)}`;
  }

  // Events without an upcoming appointment are sorted to the end
  toTime(value: Date | string | null | undefined): number {
    return value ? new Date(value).getTime() : Number.MAX_SAFE_INTEGER;
  }

  showError(message: string): void {
    this.errorText = message;
    this.showErrorDialog = true;
  }
}
